import { SkeletonFrame, SkeletonType } from '@nextgen-web-framework/all';
import { VariantEnum } from '../ContentCard';
import styles from './CardLoader.module.scss';

const CardLoader = ({ variant = VariantEnum.SEARCH_OVERLAY }: { variant?: VariantEnum }) => (
  <div
    data-testid="content-card-loader"
    className={`${styles['card-loader']} ${
      variant === VariantEnum.SRP ? styles['searchPage'] : styles['searchOverlay']
    }`}
  >
    <div className={styles['image']}>
      <SkeletonFrame className={styles.skeleton} type={SkeletonType.FULL_WIDTH} isRoundCorner />
    </div>
    <div className={styles['details']}>
      <SkeletonFrame className={styles.tag} isRoundCorner heightValue="22" />
      <SkeletonFrame className={styles.title} isRoundCorner heightValue="26" />
      <SkeletonFrame className={styles.decriptionFirstLine} isRoundCorner heightValue="22" />
      <SkeletonFrame className={styles.decriptionSecondLine} isRoundCorner heightValue="22" />
      <div className={styles['footer']}>
        <SkeletonFrame className={styles.skeleton} isRoundCorner heightValue="22" />
      </div>
    </div>
  </div>
);

export default CardLoader;
